var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { attrs: { id: "recommended-offers" } },
    [
      _vm.showEligibilityResult && _vm.recommendedOffersData.eligibilityResult
        ? _c("EligibilityResult", {
            attrs: {
              "eligibility-result": _vm.recommendedOffersData.eligibilityResult,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid mb-2 mb-md-3" }, [
        _c("div", { staticClass: "row px-1" }, [
          _c("div", { staticClass: "col-12 px-0" }, [
            _c("div", { staticClass: "container mw-100" }, [
              _c("div", { staticClass: "row px-0" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-lg-8 px-0 pe-lg-1" },
                  [
                    _c(
                      "swiper-container",
                      {
                        attrs: {
                          "uniq-swiper-id": "recommendedOffersSwiper1",
                          pagination: _vm.swiperPagination,
                          "padding-bottom-in-px": _vm.swiperPaddingBottomInPx,
                          "slides-per-view": _vm.swiperSlidesPerView,
                          "space-between": _vm.swiperSpaceBetween,
                          navigation: _vm.swiperNavigation,
                          breakpoints: _vm.swiperBreakpoints,
                        },
                      },
                      [
                        _c(
                          "swiper-slide",
                          [
                            _c("RecommendedMobileOfferTile", {
                              key: _vm.recommendedMobileOfferWithUpdatedFoLink
                                .seoId,
                              attrs: {
                                offer:
                                  _vm.recommendedMobileOfferWithUpdatedFoLink,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "swiper-slide",
                          [
                            _c("RecommendedInternetOfferTile", {
                              key: _vm.recommendedInternetOfferWithUpdatedFoLink
                                .seoId,
                              attrs: {
                                offer:
                                  _vm.recommendedInternetOfferWithUpdatedFoLink,
                                "icon-plus": _vm.recommendedOffersData.iconPlus,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-lg-4 px-0 ps-lg-1" },
                  [
                    _c("RecommendedOfferRecapTile", {
                      attrs: {
                        "eligibility-result":
                          _vm.recommendedOffersData.eligibilityResult,
                        "icon-equal": _vm.recommendedOffersData.iconEqual,
                        "internet-offer":
                          _vm.recommendedInternetOfferWithUpdatedFoLink,
                        "mobile-offer": _vm.recommendedMobileOffer,
                        "offers-total-price-label":
                          _vm.recommendedOffersData.offersTotalPriceLabel,
                        "generic-button-cta":
                          _vm.recommendedOffersData.packSummary
                            .genericButtonCta,
                        "total-price": _vm.totalPrice,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          !_vm.recommendedOffersData.eligibilityResult
            ? _c("div", { staticClass: "col-12 px-0 pt-1" }, [
                _c("a", {
                  staticClass: "ob1-link-arrow ob1-link-large",
                  attrs: {
                    href: _vm.recommendedOffersData.alternateLink.link,
                    "data-oevent-category":
                      _vm.recommendedOffersData.alternateLink.tms.category,
                    "data-oevent-action":
                      _vm.recommendedOffersData.alternateLink.tms.action,
                    "data-oevent-label":
                      _vm.recommendedOffersData.alternateLink.tms.label,
                  },
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.recommendedOffersData.alternateLink.label
                    ),
                  },
                }),
              ])
            : _vm._e(),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }